(function () {
  'use strict';

  var styleId = 'nest-header-height-box-20260717-test';
  var originalFile = 'custom-header-scroll-before-header-height-test-20260717.js';

  function assetUrl(filename) {
    var script = document.currentScript;
    var src = script && script.src ? script.src : '';
    if (!src) {
      var scripts = document.querySelectorAll('script[src*="custom-header-scroll.js"]');
      src = scripts.length ? scripts[scripts.length - 1].src : '';
    }
    return src ? src.replace(/custom-header-scroll\.js(\?.*)?$/, filename + '$1') : filename;
  }

  function loadOriginal(done) {
    var script = document.createElement('script');
    script.src = assetUrl(originalFile);
    script.async = false;
    script.onload = function () { if (done) done(); };
    script.onerror = function () { if (done) done(); };
    (document.head || document.documentElement).appendChild(script);
  }

  function installHeaderHeightStyle() {
    var style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      style.setAttribute('data-nest-theme-test', '190016455020-row-only');
      (document.head || document.documentElement).appendChild(style);
    }

    style.textContent = [
      '@media (min-width: 1021px) {',
      '  #shopify-section-header,',
      '  #shopify-section-header header.site-header,',
      '  #shopify-section-header header.site-header > nav {',
      '    height: auto !important;',
      '    max-height: none !important;',
      '    overflow: visible !important;',
      '  }',
      '  #collections-menu {',
      '    height: 80.5px !important;',
      '    max-height: 80.5px !important;',
      '    overflow: visible !important;',
      '  }',
      '}'
    ].join('\n');
  }

  function start() {
    loadOriginal(installHeaderHeightStyle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  [100, 250, 800, 1600, 3200, 5000].forEach(function (delay) {
    window.setTimeout(installHeaderHeightStyle, delay);
  });
})();
